import React from "react";
import { Container } from "react-bootstrap";
import WpImage from "../components/WpImage";
import { VectorBackground } from "../components/VectorBackground";
import { getConnectivityLogosComponentData } from "../data/components-ourpartners.data";

const HeroProduct = ({
    badge,
    header,
    text,
    image,
    ecosystemHeader,
    ecosystemDescription,
    ecosystemLogos,
    ecosystemFooterText,
    className,
}) => {
    if (!ecosystemLogos || ecosystemLogos.length === 0) {
        const compData = getConnectivityLogosComponentData();
        ecosystemLogos =
            compData?.wp?.mdaThemeOptions?.themeSettings?.connectivity?.logos ||
            [];
    }

    const logoRows = [[], []];
    if (ecosystemLogos && ecosystemLogos.length > 0) {
        ecosystemLogos.forEach((logo, index) => {
            logoRows[index % logoRows.length].push(logo);
        });
    }

    const visibleLogoRows = logoRows.filter((row) => row.length > 0);

    return (
        <section className={`hero-product ${className || ""}`}>
            <VectorBackground hideTopLine={false} variant="dark" />

            <Container className="hero-product__container">
                <div className="hero-product__content">
                    {badge && (
                        <div className="hero-product__badge">{badge}</div>
                    )}

                    {header && (
                        <h1
                            className="hero-product__header"
                            dangerouslySetInnerHTML={{ __html: header }}
                        />
                    )}

                    {text && (
                        <div
                            className="hero-product__text"
                            dangerouslySetInnerHTML={{ __html: text }}
                        />
                    )}
                </div>

                {image && (
                    <div className="hero-product__visuals">
                        <WpImage
                            image={image}
                            alt={
                                header
                                    ? header.replace(/<[^>]*>?/gm, "")
                                    : "Product Interface"
                            }
                            className="hero-product__main-image"
                        />
                    </div>
                )}

                <div className="hero-product__ecosystem">
                    {ecosystemHeader && (
                        <h2
                            className="hero-product__ecosystem-header"
                            dangerouslySetInnerHTML={{
                                __html: ecosystemHeader,
                            }}
                        />
                    )}

                    {ecosystemDescription && (
                        <div
                            className="hero-product__ecosystem-desc"
                            dangerouslySetInnerHTML={{
                                __html: ecosystemDescription,
                            }}
                        />
                    )}

                    {visibleLogoRows && visibleLogoRows.length > 0 && (
                        <div className="hero-product__ecosystem-slider-wrapper">
                            {visibleLogoRows.map((row, rowIndex) => (
                                <div
                                    className="hero-product__ecosystem-slider"
                                    key={rowIndex}
                                    style={{
                                        "--marquee-duration": `${
                                            28 + rowIndex * 6
                                        }s`,
                                        "--marquee-duration-mobile": `${
                                            rowIndex === 0 ? 72 : 60
                                        }s`,
                                    }}
                                >
                                    <div className="hero-product__ecosystem-track">
                                        {[0, 1].map((copyIndex) => (
                                            <div
                                                className="hero-product__ecosystem-slide"
                                                key={copyIndex}
                                                aria-hidden={
                                                    copyIndex === 1
                                                        ? "true"
                                                        : undefined
                                                }
                                            >
                                                {row.map(
                                                    (logo, logoIndex) =>
                                                        logo?.image && (
                                                            <div
                                                                className="hero-product__ecosystem-logo-wrapper"
                                                                key={`${copyIndex}-${logoIndex}`}
                                                            >
                                                                <WpImage
                                                                    image={
                                                                        logo.image
                                                                    }
                                                                    alt="Partner Logo"
                                                                />
                                                            </div>
                                                        )
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                            <div className="hero-product__ecosystem-divider"></div>
                        </div>
                    )}

                    {ecosystemFooterText && (
                        <div
                            className="hero-product__ecosystem-footer"
                            dangerouslySetInnerHTML={{
                                __html: ecosystemFooterText,
                            }}
                        />
                    )}
                </div>
            </Container>
        </section>
    );
};

export default HeroProduct;
